import { inject } from "@angular/core";
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";

import { ToastService } from "src/app/shared/services/toast.service";
import { TranslateService } from "@ngx-translate/core";
import { Observable, tap } from "rxjs";
import { HttpContextToken } from "@angular/common/http";

export interface ToastContext {
  message?: string;
  severity?: "success" | "error" | "warning" | "info";
  duration?: number;
}

export const TOAST_CONTEXT = new HttpContextToken<ToastContext>(() => ({}));

export const httpToastInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const toast = inject(ToastService);
  const translate = inject(TranslateService);
  const context = req.context.get(TOAST_CONTEXT);

  return next(req).pipe(
    tap({
      next: (event) => {
        if (event instanceof HttpResponse) {
          if (["POST", "PUT", "DELETE"].includes(req.method)) {
            const message =
              context.message ||
              translate.instant("messages.Operation completed successfully!");
            const duration = context.duration || 3000;
            const severity = context.severity || "success";
            if (severity === "success")
              toast.success(message, undefined, duration);
            else if (severity === "info")
              toast.info(message, undefined, duration);
            else if (severity === "warning")
              toast.warning(message, undefined, duration);
            else if (severity === "error")
              toast.error(message, undefined, duration);
          }
        }
      },
      error: (_error: HttpErrorResponse) => {
        // Siempre mostrar mensaje traducido y severidad error
        const message = translate.instant("messages.Unexpected error occurred");
        const duration = 5000;
        toast.error(message, "Error", duration);
      },
    })
  );
};
